export enum ToastType {
  success = 'toast-success',
  error = 'toast-error',
  info = 'toast-info'
}
